// customHooks/useSubscribeToMailingList.ts
import { useMutation } from '@apollo/client';
import { SUBSCRIBE_TO_MAILING_LIST } from 'graphql/service';

type SubscribeToMailingListInput = {
  email: string;
};

type SubscribeResult = {
  success: boolean;
  message?: string;
};

export const useSubscribeToMailingList = () => {
  const [subscribeToMailingList, { loading, data, error }] = useMutation(
    SUBSCRIBE_TO_MAILING_LIST
  );

  const subscribe = async ({ email }: SubscribeToMailingListInput): Promise<SubscribeResult> => {
    try {
      const res = await subscribeToMailingList({
        variables: {
          input: {
            email,
          },
        },
      });

      if (res?.data?.subscribeToMailingList?.id) {
        return {
          success: true,
          message: 'Thank you for subscribing',
        };
      }

      return {
        success: false,
        message: 'Subscribe failed!',
      };
    } catch (err: any) {
      const message =
        err?.graphQLErrors?.[0]?.message ||
        err?.networkError?.result?.errors?.[0]?.message ||
        err?.message ||
        'Subscribe failed!';

      return {
        success: false,
        message,
      };
    }
  };

  return {
    subscribe,
    loading,
    data,
    error,
  };
};